import React, { useState } from 'react';
import { Layout, Card } from 'antd';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import SearchAgentForm from "./searchAgentForm";
import SearchAgentTable from "./searchAgentTable";

import '../agent.css';

const {Content} = Layout;

function SearchAgent() {
    const [data, setData] = useState([]);
    const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE)

    function search(payload) {
        setData(payload);
    }

    const handleChangeSize = (pageSize) => {
		setPageSize(pageSize)
	}

    return (
        <div>
            <Card>
            <PageTitle pageTitle="AGENT SETUP" />
            <Content>
                <SearchAgentForm onFinish={ search }  />
                    <SearchPager 
                        pageTotal={data.length === null ? 0 : data.length}
                        pageSize={pageSize}
                        handleChangeSize={handleChangeSize}
                    />
                <SearchAgentTable data={data} pageSize={pageSize} />
            </Content>
            </Card>
        </div>
    );
}

export default SearchAgent;